import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash';
import {
  Button,
  ICONS,
  Loader,
  PLATFORM_THEME_COLORS,
  Separator,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { CommunicationChannelsEnum } from '@thinknet-gmbh/platform-common';

import { StyledRateInput } from 'src/pages/vacancies/sub-pages/vacancy-details/components/styled-rate-input';
import { useGetAllEmployeesForList } from 'src/hooks/employees/get-all-employees-for-list.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { InfoElement, HeaderContainer } from './applicant-interviews-details.styles';

const ApplicantInterviewDetails = ({
  interviews,
  onClickEdit,
}: {
  interviews: any;
  onClickEdit: () => void;
}) => {
  const { t } = useTranslation(['common', 'vacancies']);
  const companyId = useGetCurrentCompanyId();
  const { employees, loading } = useGetAllEmployeesForList({
    filter: { accountActive: true, companyId },
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      {interviews.map((item: any, index: number) => {
        const employee = employees.find((employee: any) => employee._id === item.interviewerId);

        return (
          <div key={`${index}-${item.interviewName}`}>
            <Separator />
            <HeaderContainer>
              <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                {item.interviewName}
              </Typography>
              {index === 0 && (
                <Button
                  type="primary"
                  ghost
                  icon={ICONS.editAlt}
                  iconColor={PLATFORM_THEME_COLORS.primary.blue}
                  onClick={onClickEdit}
                >
                  {t('common:buttons.edit')}
                </Button>
              )}
            </HeaderContainer>
            <div>
              <InfoElement>
                <Typography weight="bold">{t('vacancies:labels.interviewSet')}:</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {t(`common:labels.${item.interviewSet ? 'yes' : 'no'}`)}
                </Typography>
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">{t('common:labels.date')}:</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {moment(item.date).format('DD.MM.YYYY')}
                </Typography>
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">{t('vacancies:labels.interviewer')}:</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {employee.profile.displayName}
                </Typography>
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">{t('vacancies:labels.communicationChannel')}:</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {t(`vacancies:labels.${camelCase(item.communicationChannel)}`)}
                </Typography>
              </InfoElement>
              {item.communicationChannel === CommunicationChannelsEnum.ONLINE && (
                <InfoElement>
                  <Typography weight="bold">{t('vacancies:labels.linkToMeeting')}:</Typography>
                  <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                    {item.eventLink}
                  </Typography>
                </InfoElement>
              )}
              <InfoElement>
                <Typography weight="bold">{t('vacancies:labels.rating')}:</Typography>
                <StyledRateInput value={item.rating} disabled />
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">
                  {t('employee:employeeInterview.labels.feedback')}:
                </Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {item.feedback || '-'}
                </Typography>
              </InfoElement>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ApplicantInterviewDetails;
